export const MEDICAL_FORM_QUESTIONS = [
  {
    id: 'q1',
    shortDesc: 'heart',
    label: 'policies.proposal.flow.questionnaire-step.medical-form.q.q1',
  },
  {
    id: 'q2',
    shortDesc: 'blood',
    label: 'policies.proposal.flow.questionnaire-step.medical-form.q.q2',
  },
  {
    id: 'q3',
    shortDesc: 'resp',
    label: 'policies.proposal.flow.questionnaire-step.medical-form.q.q3',
  },
  {
    id: 'q4',
    shortDesc: 'neuron',
    label: 'policies.proposal.flow.questionnaire-step.medical-form.q.q4',
  },
  {
    id: 'q5',
    shortDesc: 'anxiety',
    label: 'policies.proposal.flow.questionnaire-step.medical-form.q.q5',
  },
  {
    id: 'q6',
    shortDesc: 'digestive',
    label: 'policies.proposal.flow.questionnaire-step.medical-form.q.q6',
  },
  {
    id: 'q7',
    shortDesc: 'kidney',
    label: 'policies.proposal.flow.questionnaire-step.medical-form.q.q7',
  },
  {
    id: 'q8',
    shortDesc: 'reproductive',
    label: 'policies.proposal.flow.questionnaire-step.medical-form.q.q8',
  },
  {
    id: 'q9',
    shortDesc: 'tumor',
    label: 'policies.proposal.flow.questionnaire-step.medical-form.q.q9',
  },
  {
    id: 'q10',
    shortDesc: 'ent',
    label: 'policies.proposal.flow.questionnaire-step.medical-form.q.q10',
  },
  {
    id: 'q11',
    shortDesc: 'diabetes',
    label: 'policies.proposal.flow.questionnaire-step.medical-form.q.q11',
  },
  {
    id: 'q12',
    shortDesc: 'alcohol',
    label: 'policies.proposal.flow.questionnaire-step.medical-form.q.q12',
  },
  {
    id: 'q13',
    shortDesc: 'weight',
    label: 'policies.proposal.flow.questionnaire-step.medical-form.q.q13',
  },
  {
    id: 'q14',
    shortDesc: 'monitor',
    label: 'policies.proposal.flow.questionnaire-step.medical-form.q.q14',
  },
  {
    id: 'q15',
    shortDesc: 'daily',
    label: 'policies.proposal.flow.questionnaire-step.medical-form.q.q15',
  },
  {
    id: 'q16',
    shortDesc: 'pregnant',
    label: 'policies.proposal.flow.questionnaire-step.medical-form.q.q16',
  },
  {
    id: 'q17',
    shortDesc: 'cancer',
    label: 'policies.proposal.flow.questionnaire-step.medical-form.q.q17',
  },
];
